import React from 'react';
import { SectionTitle, SectionTitleProps } from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './SectionTitleBlock.style';

export type SectionTitleBlockProps = SectionTitleProps;

export const SectionTitleBlock = ({ title }: SectionTitleBlockProps) => {
  return (
    <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsL={8}>
      <SectionTitle title={title} />
    </BlockContainer>
  );
};

export type { SectionTitleProps };
